import { isObject } from './type-guards.utils';

/**
 * helper function to flatten nested objects to single level object
 * @param oldObject
 */
export function flatten<T = object>(oldObject: object): T {
  const newObject = {};

  flattenHelper(oldObject, newObject, '');

  return (newObject as T);
}

/**
 * helper for flatten function
 * @param currentObject
 * @param newObject
 * @param previousKeyName
 */
function flattenHelper<T = { [key: string]: any }>(currentObject: object, newObject: { [key: string]: any }, previousKeyName: string) {
  for (const key in currentObject) {
    if (!currentObject.hasOwnProperty(key)) continue;
    const value: object | string = (currentObject as any)[key];

    if (!isObject(value)) {
      if (previousKeyName == null || previousKeyName === '') {
        newObject[key] = value;
      } else {
        if (key == null || key === '') {
          newObject[previousKeyName] = value;
        } else {
          newObject[`${previousKeyName}.${key}`] = value;
        }
      }
    }
    else {
      if (previousKeyName == null || previousKeyName === '') {
        flattenHelper(value, newObject, key);
      } else {
        flattenHelper(value, newObject, `${previousKeyName}.${key}`);
      }
    }
  }
}
